import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatCurrency } from "../../utils/price";

const AcceptOfferModal = ({ show, onHide, offer, onSubmit }) => {
  const handleConfirm = () => {
    onSubmit(offer?.id);
    onHide(); // close modal after submit
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Accept Offer</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to accept the offer for{" "}
          <strong>{offer?.product?.name}</strong> at{" "}
          <strong>{formatCurrency(offer?.bid_price)}</strong>?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleConfirm}>
          Accept Offer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AcceptOfferModal;
